@if(initialized) {
<div class="flex justify-content-center p-2">
  <div class="login-box">
    <form [formGroup]="formGroup">
      <div class="surface-card p-4 border-round w-full">
        <div class="text-center mb-5">
          <div class="text-color text-3xl font-medium mb-2">Erstelle dein Konto</div>
          <span class="text-color-secondary text-sm">Lade ein Profilbild hoch und lege deine Anmeldedaten fest</span>
        </div>
        <div class="flex flex-column align-items-center flex-or">
<!--          <span class="text-color mb-2 text-sm">Profile Picture</span>-->
          <div  class="h-7rem w-7rem border-circle">
            <img class="h-7rem w-7rem border-circle" [src]="imageSrc ?? 'assets/images/blank_user.png'"/>
          </div>
          <input id="upload" type="file" class="none" hidden accept="image/*" (change)="onUploadHandler($event)" *ngIf="!imageSrc" />
          <label for="upload" class="p-element p-button-rounded p-button-text surface-500 w-2rem h-2rem -mt-3 p-button p-component p-button-icon-only" *ngIf="!imageSrc">
            <span  class="p-button-icon text-sm pi pi-upload text-white" aria-hidden="true"></span>
          </label>
          <label for="delete" class="p-element p-button-rounded p-button-text  surface-500 w-2rem h-2rem -mt-3 p-button p-component p-button-icon-only" *ngIf="imageSrc">
            <span id="delete" (click)="handleDeleteImage()" class="p-button-icon text-sm pi pi-trash text-white"></span>
          </label>
        </div>


        <div class="flex flex-column gap-3">
          <div>
            <label for="email" class="block text-900 font-medium mb-2">Email<span class="text-red-500">*</span></label>
            <input id="email" formControlName="email" type="text" placeholder="Deine Email Adresse"
                   (focusout)="handleValidEmail()" pInputText class="w-full mb-1" [disabled]="busy">
            <div *ngIf="formGroup.get('email')?.errors?.['emailTaken']" class="text-red-500 mb-2 text-sm">
              {{ formGroup.get('email')?.errors?.['emailTaken'] }}
            </div>
          </div>

          <div>
            <label for="password" class="block text-900 font-medium mb-2">Passwort<span class="text-red-500">*</span></label>
            <div style="height: 0; overflow: hidden;">
              <input type="password" name="fakePassword" autocomplete="new-password" tabindex="-1"/>
            </div>
            <p-password id="password" (focusout)="handleCheckPassword()"
                        formControlName="password"
                        placeholder="Passwort eingeben"
                        styleClass="w-full" inputStyleClass="w-full"
                        [disabled]="busy"
                        [toggleMask]="true" [feedback]="false"></p-password>


            <div *ngIf="formGroup.get('password')?.errors?.['invalidPassword']" class="text-red-500 mb-2 text-sm">
              {{ formGroup.get('password')?.errors?.['invalidPassword'] }}
            </div>
          </div>

          <div>
            <label for="confirmPassword" class="block text-900 font-medium mb-2">Passwort bestätigen<span class="text-red-500">*</span></label>

            <p-password id="confirmPassword" (input)="handlePasswordMatch()" formControlName="confirmPassword"
                        styleClass="w-full" inputStyleClass="w-full"
                        [disabled]="busy"
                        [toggleMask]="true" [feedback]="false"></p-password>


            <div *ngIf="formGroup.get('confirmPassword')?.errors?.['passwordError']" class="text-red-500 mb-2 text-sm">
              {{ formGroup.get('confirmPassword')?.errors?.['passwordError'] }}
            </div>
          </div>

          <div class="flex justify-content-between col-12 py-4">

            <div>
              <p-button [disabled]="busy"
                        (click)="navigatePreviousStep(5)"
                        label="Zurück"
                        severity="secondary"
                        [text]="true"
                        iconPos="left"
                        icon="pi pi-arrow-left">
              </p-button>
            </div>

            <div>
<!--              <p-button [disabled]="!isFormValid()" (click)="finalizeRegistration()" label="Abschließen" icon="pi pi-arrow-right" iconPos="right"></p-button>-->

              <app-button [disabled]="!isFormValid()"
                          [busy]="busy"
                          [label]="'Abschließen'"
                          (onClick)="finalizeRegistration()">
              </app-button>

            </div>

          </div>

        </div>
      </div>
    </form>
  </div>
</div>

  <p-dialog
    header="Bild anpassen"
    [(visible)]="showImageCropperDialog"
    [modal]="true"
    [style]="{width: '50rem', height: '50rem'}"
    (onHide)="resetFileInput()"
  >
    <ng-template pTemplate="content">
      <div class="flex align-items-center h-full">
        <image-cropper
          *ngIf="imageChangedEvent"
          [imageChangedEvent]="imageChangedEvent"
          [maintainAspectRatio]="true"
          [aspectRatio]="1/1"
          format="png"
          (imageCropped)="imageCropped($event)">
        </image-cropper>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <button type="button" pButton label="Übernehmen" icon="pi pi-check" (click)="uploadCroppedImage()"></button>
    </ng-template>
  </p-dialog>


}
